import {createContext} from 'react'

const CatEstatusTrasladoContext = createContext()

export default CatEstatusTrasladoContext